/**
 *
 * ReportHeader
 *
 */
import React, { Fragment } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { includes, isEqual, filter, get } from "lodash"
import { Link } from "react-router-dom"
import { Button, Select, Tooltip, Skeleton } from "antd"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import PropTypes from "prop-types"
import { requestUpgradeApi } from "services/requestUpgrade"
import { DownloadOutlined } from "@ant-design/icons"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"

import reducer from "./reducer"
import saga from "./saga"
import {
  getMeditionsWatcher,
  officializeWatcher,
  setCurrentMedition,
  getMeditionsAvailableActionsWatcher,
  getMeditionsAvailableActionsFailed,
  getSurveyTypesWatcher,
  getMeasureWatcher,
} from "./actions"
import {
  makeSelectIsEmptyMeditions,
  makeSelectLoadingMeditions,
  makeSelectMeditions,
  makeSelectOfficialize,
  makeSelectOfficializeLoading,
  makeSelectAmbassadorCount,
  makeSelectMeditionAvailableActions,
  makeSelectAllMeditions,
  makeSelectIsLoadingSurveyTypes,
  makeSelectSurveyTypes,
  makeSelectMeasure,
} from "./selectors"
import "./index.less"
import {
  DISABLE,
  EXPORTABLES,
  OVERALL_RESULTS,
  ACTION_PLANS,
  AMBASSADOR_USERS,
  MEASURE_STATUS,
  TYPE_SURVEY,
} from "../../../utils/constants"
import ModalFreemium from "./components/ModalFreemium"
import ModalOfficializationOfResults from "./components/ModalOfficializationOfResults/index"

import xIcon from "../../../images/x.svg"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import {
  isModeInModuleBySlug,
  isModuleBySlug,
  LOCAL_ACTIVE_ROL,
  LOCAL_ANONYMITY,
  LOCAL_ANONYMITY_LEADERS,
} from "../../../utils/storage"
import { uuid, validate } from "../../../utils/functions"
import { loadTexts, sanitize } from "../../../utils/i18n"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class ReportHeaderV2 extends React.Component {
  intl = loadTexts("reports_general_view")
  state = {
    view_leader: false,
    showAlert: false,
    showChangeOrgAlert: true,
    currentMeasure: {},
    modalOfficialize: false,
    showLastProccess: false,
    nameView: null,
    modalActionPlanCreate: false,
    modalFreemium: false,
  }

  componentDidMount() {
    const { idMeasure, history, getMeditions, getMeasureWatcher, match, idSurveyType } = this.props

    let preSelectedDivision = null
    if(LOCAL_ACTIVE_ROL() == 5 && idSurveyType == 1){
      const searchLocation = getUrlParams(history.location.search)
      preSelectedDivision = searchLocation.id_division || searchLocation.id_divisionParent
    }

    const {
      match: { params },
    } = this.props

    getMeasureWatcher({ 
      id_measure: params.id_measure
    })
   
    getMeditions({
      idMeasure,
      history,
      match,
      id_survey_type: idSurveyType,
      preSelectedDivision
    })
    this.props.getSurveyTypesWatcher()
  }

  getNamePage(url) {
    let names = ["division", "analysis-comparative", "question", "dimensions"]
    let findPage = -1
    names.map((page) => {
      if (includes(url, page)) {
        findPage = page
      }
    })
    if (findPage !== -1) {
      this.setState({ nameView: findPage })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      meditions,
      match,
      idMeasure,
      history,
      officializeLoading,
      getAvailableActions,
      getMeasureWatcher,
      getMeditions,
      idSurveyType,
      loadingMeditions,
    } = this.props

    let preSelectedDivision = null
    if(LOCAL_ACTIVE_ROL() == 5 && idSurveyType == 1){
      const searchLocation = getUrlParams(history.location.search)
      preSelectedDivision = searchLocation.id_division || searchLocation.id_divisionParent
    }

    if (idMeasure !== nextProps.idMeasure && loadingMeditions === false) {

      getMeasureWatcher({
        id_measure: nextProps.idMeasure
      })

      // El listado de mediciones (GET companies/{id}/measure, endpoint pesado) no cambia al
      // elegir otra medición del mismo tipo: componentDidUpdate ya toma la nueva medición
      // del listado cargado. Solo se vuelve a pedir si cambia el tipo de reporte, o para el
      // embajador de clima, cuyo listado depende de la división preseleccionada.
      const surveyTypeChanged = idSurveyType !== nextProps.idSurveyType
      if (surveyTypeChanged || preSelectedDivision != null) {
        getMeditions({
          idMeasure: nextProps.idMeasure,
          history,
          match,
          id_survey_type: nextProps.idSurveyType,
          preSelectedDivision
        })
      }

      
      
    } else {
      this.getNamePage(match.url)
      let currentMeasure = nextProps.meditions.filter(
        (e) => e.id_measure == idMeasure
      )
      if (!isEqual(meditions, nextProps.meditions)) {
        if (currentMeasure.length > 0) {
          let anonimate_count = parseInt(
            currentMeasure[0].id_survey_type === 2
              ? LOCAL_ANONYMITY_LEADERS()
              : LOCAL_ANONYMITY(),
            10
          )
          this.props.setCurrentMeasure(currentMeasure[0])
          this.setState(
            {
              currentMeasure: currentMeasure[0],
              view_leader: currentMeasure[0].id_survey_type === 2,
              showAlert: currentMeasure[0].engagement_is_only
                ? currentMeasure[0].employees_engagement < anonimate_count
                : currentMeasure[0].employees_processed < anonimate_count,
            },
            () =>
              this.setState({
                showLastProccess: !this.state.showAlert,
              })
          )

          if (history.location.search === "?officialized=true") {
            this.setState({
              modalOfficialize: currentMeasure[0].officialized === 0,
            })
          }
        }
      }
      if (
        officializeLoading != nextProps.officializeLoading &&
        nextProps.officializeLoading === false
      ) {
        nextProps.meditions.map((e) => {
          if (e.id_measure == idMeasure) {
            e.officialized = 1
          }
        })
        this.setState(
          {
            modalOfficialize: false,
          },
          () => {
            const searchLocation = getUrlParams(history.location.search)
            getAvailableActions({
              measure_id: idMeasure,
              id_division: searchLocation
                ? parseInt(searchLocation.id_division)
                : null,
            })
          }
        )
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { idMeasure, meditions } = this.props
    if (prevProps.idMeasure != idMeasure) {
      let currentMeasure = meditions.filter((e) => e.id_measure == idMeasure)
      if (currentMeasure.length > 0) {
        let anonimate_count = parseInt(
          currentMeasure[0].id_survey_type === 2
            ? LOCAL_ANONYMITY_LEADERS()
            : LOCAL_ANONYMITY(),
          10
        )
        this.props.setCurrentMeasure(currentMeasure[0])
        this.setState(
          {
            currentMeasure: currentMeasure[0],
            view_leader: currentMeasure[0].id_survey_type === 2,
            showAlert: currentMeasure[0].engagement_is_only
              ? currentMeasure[0].employees_engagement < anonimate_count
              : currentMeasure[0].employees_processed < anonimate_count,
          },
          () => {
            this.setState({
              showLastProccess: !this.state.showAlert,
            })
          }
        )
      }
    }
  }

  hasSelectMeditions = () => {
    const { allMeditions } = this.props
    if (validRole({ role: [5] })) {
      return filter(allMeditions, ({ id_survey_type }) => id_survey_type !== 2)
        .length
    }
    return allMeditions.length
  }

  renderSkeletonLoading = () => {
    const { loadingMeditions } = this.props
    if (!loadingMeditions) {
      return null
    }
    return (
      <div
        style={{
          margin: "10px 2rem 0",
          paddingTop: 5,
          height: 38,
          display: "grid",
          gridGap: 100,
          gridTemplateColumns: "2fr 600px",
        }}>
        <Skeleton active title={{ width: "100%" }} paragraph={{ rows: 0 }} />
        <Skeleton active title={{ width: "100%" }} paragraph={{ rows: 0 }} />
      </div>
    )
  }

  renderModalFreemium = () => {
    const isFreemium = window.freemium()
    if (!isFreemium) {
      return null
    }
    const { modalFreemium } = this.state
    return (
      <ModalFreemium
        handleOk={() => {
          requestUpgradeApi()
          this.setState({
            modalFreemium: false,
          })
        }}
        handleCancel={() => this.setState({ modalFreemium: false })}
        isVisible={modalFreemium}
      />
    )
  }

  renderButtonOfficialize = () => {
    const { availableActions, officializeLoading } = this.props
    if (!availableActions.is_officializable) {
      return null
    }
    return (
      <Button
        loading={officializeLoading}
        className="officializeButton"
        type="primary"
        onClick={() => this.setState({ modalOfficialize: true })}>
        Oficializar resultados
      </Button>
    )
  }

  renderButtonExportable = () => {
    const { availableActions, idMeasure, idSurveyType } = this.props
    const isExportable = isModeInModuleBySlug(EXPORTABLES) !== DISABLE
    if (!availableActions.is_exportable || !isExportable) {
      return null
    }
    // if (idSurveyType !== 1) {
    //   if (idSurveyType !== 2) {
    //     return null
    //   }
    // }
    const isFreemium = window.freemium()
    if (isFreemium) {
      return (
        <Button
          type="primary"
          onClick={() => this.setState({ modalFreemium: true })}>
          {this.intl.reportHeaderV2.headerContent.buttonExportable}
        </Button>
      )
    }
    return (
      <Link
        className="ant-btn ant-btn-primary"
        to={`/reports/export/measure/${idMeasure}`}
        onClick={() => woopraTrack("Generar reporte")}>
        {this.intl.reportHeaderV2.headerContent.buttonExportable}
      </Link>
    )
  }

  renderButtonActionPlan = () => {
    const { availableActions } = this.props
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    if (!isActionPlans || !availableActions.is_action_plan_creatable) {
      return null
    }
    return (
      <Button
        type="primary"
        style={{ marginRight: 9, color: '#FFFFFF' }}
        onClick={() => {
          woopraTrack("Crear plan de acción")
          this.setState({ modalActionPlanCreate: true })
        }}>
        <span style={{color: '#ffffff'}}>{this.intl.reportHeaderV2.headerContent.buttonActionPlan}</span>
      </Button>
    )
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  renderChangeOrganizationContent = () => {
    if([3, 4].includes(get(this.props, 'measure.id_measure_status')) && get(this.props, 'measure.force_reprocess') && this.state.showChangeOrgAlert) {
      return (
        <div className="measurement-details-alert">
          <span>Se han realizado modificaciones en los destinatarios de esta medición. Los <b>resultados</b> del reporte <b>serán reprocesados</b>.</span>
          <img src={xIcon} onClick={() => this.setState({ showChangeOrgAlert: false })} />
        </div>
      )
    }
  }

  renderAlertContent = () => {
    const { showAlert, view_leader } = this.state
    if (!showAlert) {
      return null
    }
    let anonimate_count = parseInt(
      view_leader ? LOCAL_ANONYMITY_LEADERS() : LOCAL_ANONYMITY(),
      10
    )

    const language = localStorage.getItem("language")
    return (
      <div className="measurement-details-alert">
        <span>
          {language == "es"
            ? sanitize(this.intl.reportHeaderV2.alertContent.details.section1)
            : sanitize(
                `${this.intl.reportHeaderV2.alertContent.details.section1} ${anonimate_count} ${this.intl.reportHeaderV2.alertContent.details.section2}`
              )}
          {language == "es" && (
            <strong>
              {anonimate_count +
                this.intl.reportHeaderV2.alertContent.details.section4}
              {view_leader
                ? this.intl.reportHeaderV2.alertContent.details.team
                : this.intl.reportHeaderV2.alertContent.details.division}
            </strong>
          )}
          .
        </span>
        <img src={xIcon} onClick={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  setName = (surveyTypes, idSurveyType) => {
    let response =
      surveyTypes && surveyTypes.length > 0
        ? surveyTypes.find((element) => element.id_survey_type === idSurveyType)
        : ""

    return validate.exist(response) && !validate.empty(response)
      ? response.survey_type_name
      : ""
  }

  renderHeaderContent = () => {
    const {
      visibleHeader,
      surveyTypes,
      idSurveyType,
      idMeasure,
      meditions,
    } = this.props
    if (!visibleHeader) {
      return null
    }
    const newMeditions = [...meditions]
    const selectedMeasure = newMeditions.filter(
      (med) => med.id_measure === idMeasure
    )
    const isOverallResults = isModuleBySlug(OVERALL_RESULTS)
    return (
      <Fragment>
        <div key="title-ReportHeader" className="ReportHeader-title">
          <Link to="/reports/dashboard">
            <span style={{ color: "#2694FC" }}>
              {`< ${this.intl.reportHeaderV2.headerContent.title}`}
            </span>
          </Link>
          <div
            style={{
              fontWeight: 600,
              fontSize: "16px",
              marginTop: "16px",
              marginBottom: "16px",
            }}>
            {this.setName(surveyTypes, idSurveyType)}{" "}
            {selectedMeasure.length > 0 && selectedMeasure[0].engagement && (
              <span
                style={{
                  marginLeft: "8px",
                  padding: "4px 8px",
                  borderRadius: "3px",
                  background: "rgba(44, 91, 255, 0.1)",
                  color: "#2C5BFF",
                  fontWeight: "600",
                }}>
                Engagement
              </span>
            )}
          </div>
          {isOverallResults && (
            <div key="ReportHeader-buttons" className="ReportHeader-buttons" style={{ top: [3,4].includes(get(this.props, "measure.id_measure_status")) && get(this.props, "measure.force_reprocess") ? 80 : 25 }}>
              {this.renderButtonActionPlan()}
              {this.renderButtonExportable()}
              {this.renderButtonOfficialize()}
            </div>
          )}
        </div>
        
      </Fragment>
    )
  }

  renderIconExportReport = () => {
    const { showDownload, availableActions, idMeasure } = this.props
    const { nameView } = this.state
    if (!availableActions.is_exportable || !showDownload) {
      return null
    }
    const isFreemium = window.freemium()
    let iconExportReport = (
      <Link
        style={{
          height: 30,
          borderRadius: 1,
          padding: "0 9px",
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
          borderWidth: 0,
        }}
        className="ant-btn"
        to={`/reports/export/measure/${idMeasure}${nameView !== null &&
          `/${nameView}`}`}>
        <DownloadOutlined
          style={{ verticalAlign: "baseline", color: "#1890ff" }}
          twoToneColor="#1890ff"
        />
      </Link>
    )
    if (isFreemium) {
      iconExportReport = (
        <span
          style={{
            height: 30,
            borderRadius: 1,
            padding: "0 9px",
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
            borderWidth: 0,
          }}
          className="ant-btn"
          onClick={() => this.setState({ modalFreemium: true })}>
          <DownloadOutlined
            style={{ verticalAlign: "sub", color: "#1890ff" }}
            twoToneColor="#1890ff"
          />
        </span>
      )
    }
    return (
      <div style={{ textAlign: "right" }}>
        {iconExportReport}
        <div />
      </div>
    )
  }

  renderMeditionContent = () => {
    const {
      showDownload,
      isHome,
      hideMeditions,
      meditions,
      isEmptyMeditions,
      rightWidth,
      availableActions,
      idMeasure,
      idSurveyType,
      history,
    } = this.props

    let meditionsFilters = getUniqueListBy(meditions, "id_measure")

    const { currentMeasure, showLastProccess } = this.state
    const { measureGeneralSelected } = this.props
    const isOverallResults = isModuleBySlug(OVERALL_RESULTS)
    if (hideMeditions || isEmptyMeditions || !isOverallResults) {
      return <div style={{ height: 30 }} />
    }
    let styleHeaderMedition = {
      gridTemplateColumns: `90px auto ${rightWidth}`,
      gridGap: 10,
    }
    if (!availableActions.is_exportable || !showDownload) {
      styleHeaderMedition = {
        gridTemplateColumns:
          showLastProccess &&
          currentMeasure.date_processed &&
          currentMeasure.employees_processed
            ? this.hasSelectMeditions() > 1
              ? "100px auto 630px"
              : "100px auto 380px"
            : "100px auto 245px",
      }
    }
    const measureInProgress = MEASURE_STATUS.in_progress
    const searchLocation = getUrlParams(history.location.search)
    const id_divisionParent = searchLocation
      ? searchLocation.id_divisionParent
      : null
    const id_division = searchLocation ? searchLocation.id_division : null
    return (
      <div className="ReportHeader-meditions" style={styleHeaderMedition}>
        <span className="ReportHeader-meditions-title">
          {this.intl.reportHeaderV2.meditionContent.labelMeasures}
        </span>

        {Array.isArray(meditionsFilters) && (
          <Select
            placeholder="Seleccionar medición"
            style={{ width: 250 }}
            onChange={(id_measure) =>{

              let urlMeasure = `/reports/measure/${idSurveyType}/${id_measure}`

              meditionsFilters.map((measure) => {
                if (measure.id_division != null && measure.id_division != 0 && measure.id_measure == id_measure && idSurveyType == TYPE_SURVEY.climate.idSurveyType){
                  urlMeasure = `/reports/measure/${idSurveyType}/${id_measure}?id_division=${measure.id_division}&id_divisionParent=${measure.id_division}`
                }
              })

              history.push(urlMeasure)}
            }
            value={Number(idMeasure)}>
            {Array.isArray(meditionsFilters) &&
              meditionsFilters.map((e) => {
                return (
                  <Option
                    key={e.id_measure + uuid()}
                    value={e.id_measure}
                    className={
                      e.id_measure_status ===
                      measureInProgress.id_measure_status
                        ? "ReportHeader-meditions-current"
                        : ""
                    }>
                    <Tooltip
                      placement="leftTop"
                      title={e.name}
                      align={{
                        offset: [-8, -6],
                      }}>
                      {e.name}
                    </Tooltip>
                  </Option>
                )
              })}
          </Select>
        )}

        {isHome && (
          <div className="ReportHeader-select-meditions">
            {showLastProccess &&
              measureGeneralSelected.date_processed &&
              measureGeneralSelected.employees_processed && (
                <span>
                  {this.intl.reportHeaderV2.meditionContent.lastProcess +
                    measureGeneralSelected.date_processed}
                </span>
              )}
          </div>
        )}

        {this.renderIconExportReport()}
      </div>
    )
  }

  render() {
    const {
      officializeLoading,
      ambassadorCount,
      officializeWatcher,
      idMeasure,
    } = this.props
    const { view_leader, modalOfficialize, modalActionPlanCreate } = this.state
    const { idSurveyType } = this.props
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    return (
      <div className="ReportHeader">
        {this.renderChangeOrganizationContent()}
        {this.renderAlertContent()}
        {this.renderHeaderContent()}
        {this.renderSkeletonLoading()}
        {this.renderMeditionContent()}

        { idSurveyType == 1 && <ModalActionPlanCreate
          visible={modalActionPlanCreate}
          onCancel={() => this.setState({ modalActionPlanCreate: false })}
        />}

        <ModalOfficializationOfResults
          measure={idMeasure}
          isLoading={officializeLoading}
          isVisible={modalOfficialize}
          onCancel={() => this.setState({ modalOfficialize: false })}
          officializeWatcher={officializeWatcher}
          isAmbassador={isAmbassador && !view_leader && ambassadorCount > 0}
        />

        {this.renderModalFreemium()}
      </div>
    )
  }
}

ReportHeaderV2.defaultProps = {
  rightWidth: "46px",
}

ReportHeaderV2.propTypes = {
  rightWidth: PropTypes.string,
  isHome: PropTypes.bool,
  match: PropTypes.object,
  visibleHeader: PropTypes.bool,
  idMeasure: PropTypes.number,
  history: PropTypes.object,
  setCurrentMeasure: PropTypes.func,
  idSurveyType: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isEmptyMeditions: makeSelectIsEmptyMeditions(),
  loadingMeditions: makeSelectLoadingMeditions(),
  isLoadingSurveyTypes: makeSelectIsLoadingSurveyTypes(),
  surveyTypes: makeSelectSurveyTypes(),
  meditions: makeSelectMeditions(),
  officialize: makeSelectOfficialize(),
  officializeLoading: makeSelectOfficializeLoading(),
  ambassadorCount: makeSelectAmbassadorCount(),
  availableActions: makeSelectMeditionAvailableActions(),
  allMeditions: makeSelectAllMeditions(),
  measure: makeSelectMeasure()
})

function mapDispatchToProps(dispatch) {
  return {
    getMeasureWatcher: (params) => dispatch(getMeasureWatcher(params)),
    officializeWatcher: (params) => dispatch(officializeWatcher(params)),
    setCurrentMeditionWatcher: (params) => dispatch(setCurrentMedition(params)),
    getSurveyTypesWatcher: () => dispatch(getSurveyTypesWatcher()),
    getMeditions: (params) => dispatch(getMeditionsWatcher(params)),
    getAvailableActions: (params) =>
      dispatch(getMeditionsAvailableActionsWatcher(params)),
    getAvailableActionsFailed: () =>
      dispatch(getMeditionsAvailableActionsFailed()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reportHeaderV2", reducer })
const withSaga = injectSaga({ key: "reportHeaderV2", saga })

export default compose(withReducer, withSaga, withConnect)(ReportHeaderV2)
